import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "AddUsagerModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "AddUsagerModalRef"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-3 col-sm-12 col-xs-12 col-lg-3 col-xl-3 col-xxl-3" }
const _hoisted_7 = { class: "upload-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "text-center"
}
const _hoisted_10 = { class: "col-md-9 col-sm-12 col-xs-12 col-lg-9 col-xl-9 col-xxl-9" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6 col-sm-12" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "col-md-6 col-sm-12" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "col-md-6 col-sm-12" }
const _hoisted_17 = { class: "form-group mb-15" }
const _hoisted_18 = { class: "col-md-6 col-sm-12" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "col-md-6 col-sm-12" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "col-md-6 col-sm-12" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "col-md-6 col-sm-12" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "col-md-6 col-sm-12" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "col-md-6 col-sm-12" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "col-md-6 col-sm-12" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "col-md-12 mt-5" }
const _hoisted_33 = { class: "product-upload mb-10" }
const _hoisted_34 = { class: "dz-message needsclick" }
const _hoisted_35 = {
  key: 0,
  class: "default-image-container"
}
const _hoisted_36 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_DropZone = _resolveComponent("DropZone")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h1", { class: "modal-title fs-5" }, "Usager"),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            ref: "usagerForm",
            onSubmit: _ctx.soumettre,
            "validation-schema": _ctx.usagerSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("input", {
                      type: "file",
                      name: "urlImage",
                      ref: "fileInput",
                      onChange: _cache[0] || (_cache[0] = (event) => _ctx.onFilePrinChange(event)),
                      accept: "image/*",
                      hidden: ""
                    }, null, 544),
                    _createElementVNode("div", {
                      class: "preview-card",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                    }, [
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.imagePreview,
                            alt: "Image preview"
                          }, null, 8, _hoisted_8))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("i", { class: "flaticon-camera fs-1" })
                            ], -1),
                            _createTextVNode(" Cliquez pour ajouter l'image principal du produit ", -1)
                          ]))])),
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "delete-btn",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)), ["stop"]))
                          }, [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("i", { class: "flaticon-close" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Nom "),
                          _createElementVNode("span", { class: "text-danger" })
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "nom",
                          modelValue: _ctx.nom,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nom) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Renseigner le nom"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "nom",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Prénom "),
                          _createElementVNode("span", { class: "text-danger" })
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "prenom",
                          type: "text",
                          modelValue: _ctx.prenom,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.prenom) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Renseigner le prénom"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "prenom",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Date de naissance "),
                          _createElementVNode("span", { class: "text-danger" })
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "dateNaissance",
                          modelValue: _ctx.dateNaissance,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dateNaissance) = $event)),
                          type: "date",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Renseigner votre date de naissance"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "dateNaissance",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" NIP "),
                          _createElementVNode("span", { class: "text-danger" })
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "npi",
                          modelValue: _ctx.nip,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.nip) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Renseigner le NPI"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "npi",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Adresse "),
                          _createElementVNode("span", { class: "text-danger" })
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "adresse",
                          modelValue: _ctx.adresse,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.adresse) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Renseigner l'adresse"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "adresse",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Téléphone "),
                          _createElementVNode("span", { class: "text-danger" })
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "tel",
                          modelValue: _ctx.telephone,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.telephone) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Renseigner l'adresse"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "tel",
                          class: "text-danger"
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" IFU "),
                      _createElementVNode("span", { class: "text-danger" })
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "ifu",
                      modelValue: _ctx.ifu,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ifu) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "XXXXXXXXXXXX"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "ifu",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Sexe ", -1)),
                    _createVNode(_component_Field, {
                      name: "sexe",
                      modelValue: _ctx.sexe,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sexe) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.sexes,
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner un sexe" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "sexe",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Activite ", -1)),
                    _createVNode(_component_Field, {
                      name: "activite",
                      modelValue: _ctx.activite,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.activite) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.activites,
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner une activité" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "activite",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" Plus detail activité "),
                      _createElementVNode("span", { class: "text-danger" })
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "nouveau_activite",
                      modelValue: _ctx.nouveau_activite,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.nouveau_activite) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Tomate"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nouveau_activite",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_DropZone, {
                        name: "fichiers[]",
                        maxFilesize: 50000000,
                        maxFiles: Number(10000000000),
                        class: "",
                        uploadOnDrop: true,
                        onAddedFile: _ctx.onFileAdd,
                        onRemovedFile: _ctx.onFileRemove,
                        options: _ctx.dropzoneOptions,
                        onVdropzoneSuccess: _ctx.onSuccess,
                        onVdropzoneError: _ctx.onError
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.hasFiles)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("img", {
                                  src: _ctx.defaultImage,
                                  alt: "Default",
                                  class: "default-image"
                                }, null, 8, _hoisted_36),
                                _cache[25] || (_cache[25] = _createElementVNode("p", null, "Glissez et dépossez ici", -1))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["maxFiles", "onAddedFile", "onRemovedFile", "options", "onVdropzoneSuccess", "onVdropzoneError"])
                    ])
                  ])
                ])
              ]),
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "row mt-5" }, [
                _createElementVNode("div", { class: "col-md-3 text-md-end text-xl-end text-sm-center col-sm-12" }, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary w-100"
                  }, " Enregistrer ")
                ])
              ], -1))
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal"
          }, " Fermer ")
        ], -1))
      ])
    ])
  ], 512))
}